import { BadgeCheck } from "lucide-react";

export default function VerifiedBadge({ size = 16, className = "" }) {
  return (
    <span title="Verified artist" className={`inline-flex align-middle text-[#FF4500] ${className}`}>
      <BadgeCheck size={size} strokeWidth={2.5} />
    </span>
  );
}
